import { gql } from 'graphql-request';
import { EventExportFragment } from './EventExportFragment';

export const MagicEventFragment = gql`
  ${EventExportFragment}
  fragment MagicEvent on Event {
    id
    createdAt
    updatedAt
    title
    emoji
    imageUrl
    imageId
    description
    locationWithPlace {
      name
      googlePlaceId
    }
    isAllDay
    rrule
    start {
      date
      dateTime
      timeZone
    }
    end {
      date
      dateTime
      timeZone
    }
    lastEndDate
    lastEndDateTime
    kind
    shortTitle
    version
    exports {
      ...EventExport
    }
    # The per-experience overrides for the page this event belongs to, or that a
    # staged chat event is being drafted for. Selected here rather than on
    # ExperienceEvent because the Magic surfaces edit a category before the
    # events reach the page: an add-content card's MetadataPickers reads it
    # through asExperienceEvent, which passes any metadata already on the event
    # straight through.
    #
    # The whole block lives here, not just category, so there is exactly one
    # metadata shape across DecoratedEvent. Splitting it left the two arms of
    # the union with structurally incompatible metadata, which broke every
    # helper that takes the narrow { kind } or { emoji } shape.
    #
    # The server resolves these from the chat's bound experience (see
    # withExperienceId in the API's resolvers/events.ts); an unbound /magic chat
    # has no page, so every field comes back empty.
    metadata {
      category {
        id
        text
        color
        colorName
        sortOrder
      }
      hidden
      # Occurrences hidden on the pages between this one and the event's
      # source. They are not this page's to unhide, so the expanders drop them
      # whatever the reveal state, see features/events/lib/eventVisibility.lib.
      inheritedHidden
      # This experience's override of the event's own kind, above. Null means
      # inherit, see features/events/lib/eventKind.lib.ts.
      kind
      # Likewise for the event's own emoji, above, except the coalesce has a
      # third tier between them (the feed default), see
      # features/events/lib/eventEmoji.lib.ts.
      emoji
      # The per-experience note on an event fed in from a source this experience
      # cannot write. Unlike its neighbours there is nothing to coalesce it
      # against: notes has no twin on the event and no feed default, so what the
      # server returns is the whole value.
      notes
      labels {
        id
        text
        sortOrder
      }
      whoLabels {
        id
        text
        sortOrder
      }
    }
  }
`;
